// Entrada do chat de suporte: aparece só para usuário logado e só se o servidor o ligar
// (`status`: chave da IA + base presentes). API anterior sem a rota, ou desligada: não renderiza nada.
import { useEffect, useState } from "react";
import { authFetch } from "../api";
import { API } from "./conversas";
import SuporteIA from "./SuporteIA";

export default function SuporteIAFlutuante() {
  // null = desligado ou ainda sem resposta; objeto = ligado (chamado: o servidor consegue abrir caso na Área do Cliente).
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let vivo = true;
    authFetch(`${API}/status/`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (vivo && d?.ativo === true) setStatus({ chamado: d.chamado === true });
      })
      .catch(() => {});
    return () => {
      vivo = false;
    };
  }, []);

  return status === null ? null : <SuporteIA chamadoAtivo={status.chamado} />;
}
